/**
 * Promise-based confirm API backed by ConfirmAlertHost (shadcn Alert Dialog).
 * Drop-in async replacement for window.confirm in React surfaces.
 */

let _show = null;

export function registerConfirmAlert(showFn) {
  _show = showFn;
}

/**
 * @param {object} options
 * @param {string} [options.title='Confirm']
 * @param {string} [options.message='']
 * @param {string} [options.confirmLabel='Confirm']
 * @param {string} [options.cancelLabel='Cancel']
 * @param {string} [options.confirmClass='btn-primary'] — e.g. btn-danger
 * @returns {Promise<boolean>}
 */
export function confirmAlert(options = {}) {
  if (typeof _show === 'function') {
    return _show(options);
  }
  // Host not mounted yet — last-resort sync fallback (should not happen in app)
  const text = options.message || options.title || 'Confirm?';
  return Promise.resolve(window.confirm(text));
}
